import * as THREE from "three";
import { HqMaterials } from "../hqMaterials";
import { RoadPave } from "../groundPave";
import type { RoadSurface } from "./kit/types";

/**
 * Road skins (FINISH_PLAN WP8): a colour multiplier on the built road's cobbles. The ground mesh's shader reads
 * `RoadSkin.tint` (groundMesh.ts binds it as `uRoadTint`, groundShader.ts multiplies the road albedo by it), and the
 * tile road of a level without the ground mesh gets the same tint through HqMaterials.setRoadTint. Only the road the
 * player builds: the flagstone pads under towers and the card's preview glow keep their look.
 */
export class RoadSkin {
  /** The painted cobble's stock grade (was the constant in groundShader.ts): at or under 1 so the sunlit road never blooms. */
  static readonly StockGrade: readonly [number, number, number] = [1.0, 0.95, 0.84];
  /** The shader's uniform: the stock grade times the worn skin's multiplier. */
  static readonly tint = { value: new THREE.Color(...RoadSkin.StockGrade) };

  /**
   * Wears a road skin's multiplier (linear RGB), or the stock cobble for null, and its own paving on the ground-mesh
   * road (groundPave.ts; null: the cobble). Takes effect at once.
   */
  static set(mult: readonly [number, number, number] | null, surface: RoadSurface | null = null): void {
    const m = new THREE.Color(...(mult ?? [1, 1, 1]));
    RoadSkin.tint.value.setRGB(...RoadSkin.StockGrade).multiply(m);
    HqMaterials.setRoadTint(m);
    RoadPave.set(surface);
  }
}
